// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_upload_error-module__message--1eqXd{font-weight:500;font-size:14px;line-height:21px;letter-spacing:0;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%}.decision_upload_error-module__help--2O4ud{text-decoration:underline;cursor:pointer;font-weight:500;font-size:14px;line-height:21px;letter-spacing:0;padding:0}\n", ""]);
// Exports
exports.locals = {
	"message": "decision_upload_error-module__message--1eqXd",
	"help": "decision_upload_error-module__help--2O4ud"
};
module.exports = exports;
